const $ = window.jQuery;

const asyncFunc = window.requestIdleCallback || window.requestAnimationFrame;

const getArrowHtml = (direction, label) =>
  `<button class="paddle paddle-${direction}"><i class="fa fa-chevron-${direction}"></i><span class="visually-hidden">Carousel ${label}</span></button>`;

const CAROUSEL_DEFAULT = {
  dots: true,
  infinite: true,
  nextArrow: getArrowHtml('right', 'next'),
  prevArrow: getArrowHtml('left', 'previous'),
  rows: 0,
  slidesToScroll: 6,
  slidesToShow: 6,
  responsive: [
    {
      breakpoint: 928,
      settings: {
        arrows: false,
        dots: false,
        infinite: false,
        slidesToScroll: 4,
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 600,
      settings: {
        arrows: false,
        dots: false,
        infinite: false,
        slidesToScroll: 2,
        slidesToShow: 2.5,
      },
    },
  ],
};

const CAROUSEL_SPILLOVER = Object.assign({}, CAROUSEL_DEFAULT, {
  slidesToScroll: 5,
  slidesToShow: 5,
});
CAROUSEL_SPILLOVER.responsive[1].settings.slidesToShow = 2; // override 2.5

const FADE_IN_ANIMATION = { animation: 'fadein 0.4s forwards' };

function loadRecommender(recommender) {
  const $recommender = $(recommender);

  $recommender.find('img.lazy').each(function () {
    const src = $(this).data('src');
    $(this).css('visibility', 'visible');
    $(this).attr('src', src);
  });

  $recommender.css(FADE_IN_ANIMATION);
}

function loadSlick() {
  const slickImport = import(/* webpackChunkName: "slick" */ '../vendor/slick.js');

  return slickImport.then(() => {
    $('.recommender-carousel').slick(CAROUSEL_DEFAULT);
    $('.spillover-carousel').slick(CAROUSEL_SPILLOVER);
  });
}

function initRecommenders() {
  const $recommenders = $('.recommender-wrapper');

  let slickLoaded = false;

  try {
    $recommenders.get().forEach((recommender) => {
      let observer;

      const handleRecommender = () => {
        loadRecommender(recommender);

        observer.unobserve(recommender);
      };

      const observerCallback = ([observedElement]) => {
        if (!observedElement.isIntersecting) return;

        if (!slickLoaded) {
          slickLoaded = true;

          return loadSlick().then(handleRecommender);
        }

        handleRecommender();
      };

      observer = new IntersectionObserver(observerCallback);

      observer.observe(recommender);
    });
  } catch (error) {
    console.log('Error in recommendations:', error); // eslint-disable-line no-console

    $recommenders.css(FADE_IN_ANIMATION);
  }
}

asyncFunc(initRecommenders);
